import React from 'react';
//utils
import {safeGet} from '../../../../../utils';
//childrens
import AccountSection from  '../AccountSection';
import Checkbox from '../../../../common/Checkbox/Checkbox';
import {Translations,convertStringToArrayForOption} from '../../../../../utils';
//style
import './SweepSelectionList.css';

export default class SweepSelectionList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sweepSelections: props.sweepSelections || [],
      sweepCheckedState: {}
    };
  }

  componentDidMount() {
    var sweepCheckedState = {};
    this.state.sweepSelections.forEach(sweepId => {
      sweepCheckedState[sweepId] = true;
    });
    this.setState({sweepCheckedState});
  }

  componentWillReceiveProps({sweepSelections}) {
    if(sweepSelections === undefined || sweepSelections.length === 0) {
      this.setState({
        sweepSelections: [],
        sweepCheckedState: {}
      });
    }
  }

  onSweepSelected = (id, event) => {
    var sweepSelections = [...this.state.sweepSelections];
    if(event.target.checked) {
      sweepSelections.push(id);
      this.setState({
        sweepSelections,
        sweepCheckedState: {...this.state.sweepCheckedState, [id]: true}
      });
    }else {
      sweepSelections.remove(id);
      this.setState({
        sweepSelections,
        sweepCheckedState: {...this.state.sweepCheckedState, [id]: false}
      });
    }
    this.props.onSelectionChanged(sweepSelections);
  }

  // getSweepTypeJsx = (item) => {
  //   var sweepType = safeGet(item, "sweepParticipantsAccounts.sweepType.name");
  //   var accountRegion = safeGet(item,"sweepParticipantsAccounts.accountRegion");
  //   if(sweepType !== '' && accountRegion !== '') {
  //     return `${sweepType}, ${accountRegion}`;
  //   }else if(sweepType !== '') {
  //     return sweepType;
  //   }
  // }

  getSweepName(type){
    let name;
    if(this.props.sweepTypes !== undefined){
      this.props.sweepTypes .filter(countItem => {
            if (countItem.id === type) {
              name = countItem.name
            }
          })
          return name;
  }
}

  getSweepTypeJsx = (item) => {
    var currentWord = this.props.pageJson !==undefined && this.props.pageJson.staticText_sweepInstructions !== undefined ? Translations(this.props.pageJson.staticText_sweepInstructions.region,this.props.lang.currentLang.lang, this.props.lang.translatedData) : '';
    const region = convertStringToArrayForOption(currentWord);
    var sweepType = this.getSweepName(safeGet(item, "sweepParticipantsAccounts.sweepType.value"));
    var accountRegion = safeGet(item,"sweepParticipantsAccounts.accountRegion");
    if(sweepType !== '' && accountRegion !== '') {
      if(accountRegion === 'crossBorder')
      {accountRegion = region !== undefined ? region[0].split("=")[1] : ''}
      else{accountRegion = region !== undefined ? region[1].split("=")[1] : ''}
      return `${sweepType}, ${accountRegion}`;
    }else if(sweepType !== '') {
      return sweepType;
    }
  }

  render() {
    return (
      <div className="sweep-instructions-selection-wrapper">
        {
          this.props.sweepInstructions.map((item, index) => (
            <div className="sweep-instruction" key={item.id || index}>
              <div className="sweep-instruction__checkbox">
                <Checkbox onChange={this.onSweepSelected.bind(this, item.id)}
                          checked={this.state.sweepCheckedState[item.id]}
                          controlled />
              </div>
              <div className="sweep-instruction__sweep-details">
                <label className="sweep-instruction__sweep-details__sweep-name">
                  {item.sweepId} <span>({item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.currency !== undefined ? item.sweepParticipantsAccounts.currency.name :''})</span>
                </label>
                <p className="sweep-instruction__sweep-details__sweep-type">
                  {this.getSweepTypeJsx(item)}
                </p>
              </div>
              <AccountSection type="master" master={this.props.pageJson !==undefined ? Translations(this.props.pageJson.staticText_sweepInstructions.master,this.props.lang.currentLang.lang, this.props.lang.translatedData) : ''}
              sweepInstruction={item} accounts={this.props.accounts} />
              <AccountSection type="sub" sub={this.props.pageJson !==undefined ? Translations(this.props.pageJson.staticText_sweepInstructions.sub,this.props.lang.currentLang.lang, this.props.lang.translatedData) : ''}
              sweepInstruction={item} accounts={this.props.accounts} />
            </div>
          ))
        }
      </div>
    );
  }
}

// isSweepSelected = (id) => {
//   return this.state.sweepSelections.indexOf(id) !== -1;
// }
//
// <Checkbox onChange={this.onSweepSelected.bind(this, item.id)}
//           defaultChecked={this.isSweepSelected(item.id)} />



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CaptureProductGlsCashCon/SweepSelectionList/SweepSelectionList.js